
import { useSEO } from "@/hooks/useSEO";
import { useSiteSettings } from "@/hooks/useSiteSettings";
import Header from "@/components/header/ModernHeader";
import HeroSection from "@/components/homepage/HeroSection";
import OnSaleCarousel from "@/components/homepage/OnSaleCarousel";
import CallToActionSection from "@/components/homepage/CallToActionSection";
import FeaturedProducts from "@/components/FeaturedProducts";
import FeaturesSection from "@/components/homepage/FeaturesSection";
import ParallaxBackground from "@/components/homepage/ParallaxBackground";
import Footer from "@/components/Footer";
import BrandStoriesCarousel from "@/components/homepage/BrandStoriesCarousel";
import InteractivePhotoGallery from "@/components/homepage/InteractivePhotoGallery";
import TrustIndicatorsBar from "@/components/homepage/TrustIndicatorsBar";

const Home = () => {
  const { data: siteSettings } = useSiteSettings();

  // Custom schema for homepage
  const homepageSchema = siteSettings ? {
    "@context": "https://schema.org/",
    "@type": "WebPage",
    "name": siteSettings.seoTitle || `${siteSettings.siteName} - Home`,
    "description": siteSettings.seoDescription || siteSettings.siteDescription,
    "url": window.location.href,
    "isPartOf": {
      "@type": "WebSite",
      "name": siteSettings.businessName || siteSettings.siteName,
      "url": siteSettings.canonicalUrl || window.location.origin
    },
    "about": {
      "@type": "Organization",
      "name": siteSettings.businessName || siteSettings.siteName
    }
  } : null;

  // Use SEO hook with homepage-specific settings
  useSEO({
    pageType: 'home',
    customTitle: siteSettings?.seoTitle,
    customDescription: siteSettings?.seoDescription,
    customKeywords: siteSettings?.seoKeywords,
    customSchema: homepageSchema,
    customImage: siteSettings?.ogImageUrl
  });

  return (
    <div className="min-h-screen bg-background relative">
      <Header />
      <ParallaxBackground />
      <div className="relative z-20">
        <HeroSection />
        <FeaturedProducts />
        <BrandStoriesCarousel />
        <InteractivePhotoGallery />
        <OnSaleCarousel />
        <FeaturesSection />
        <CallToActionSection />
        <TrustIndicatorsBar />
        <Footer />
      </div>
    </div>
  );
};

export default Home;
